<template>
  <div class="md-layout">
    <div v-if="$route.params.id" id="objectHeaderContentHidden" style="display: none;">
      <div>
        <md-icon class="icon-color">{{formConfig.headerIcon}}</md-icon>
      </div>
      <div>
        <h1 class="md-title icon-color content-wrap">{{recordData? recordData.name : ''}}</h1>
      </div>
    </div>
    <template v-if="$route.params.id">

      <md-tabs md-sync-route class="topNavTabs" :class="[
        { 'edit-mode': formConfig.pageMode == 'new' || formConfig.pageMode == 'edit' },
      ]">
        <md-tab id="tab-hq" md-label="HQ" :to="recordPath" exact>
          <div class="md-card md-layout-item md-small-size-100" >
          <ConfigForm
            :update="updateForm"
            :form="form"
            :$v="$v"
            :formConfig.sync="formConfig"
            :headerColor="headerColor"
          ></ConfigForm>
          </div>
        </md-tab>
        <md-tab id="tab-companies" md-label="Companies" :to="recordPath + '/companies'">
          <ElasticList
            v-if="$route && $route.meta.tab === 'companies'"
            :list.sync="companiesList"
            :filter="companyHqId"
            ref="companyListRef"
          ></ElasticList>

          <!-- Companies Dialog -->
          <md-dialog :md-active.sync="companiesList.showRelatedDialog">
            <md-dialog-title>{{relateCompaniesList.pageTitle}}</md-dialog-title>
            <md-dialog-content>
              <ElasticList
                v-if="recordData"
                :list.sync="relateCompaniesList"
                :rawFilter="companyHqNullFilter"
                :relateRecordInput="{companyHqId: $route.params.id}"
                relateRecordInputField="id"
              ></ElasticList>
            </md-dialog-content>
            <md-dialog-actions>
              <md-button
                class="md-theme-default"
                @click="companiesList.showRelatedDialog = false"
              >Close</md-button>
            </md-dialog-actions>
          </md-dialog>
        </md-tab>
      </md-tabs>
    </template>

    <div v-else class="md-tabs topNavTabs md-alignment-left md-theme-default" :class="[
        { 'edit-mode': formConfig.pageMode == 'new' || formConfig.pageMode == 'edit' },
      ]"> 
      <div class="md-content md-tabs-content md-theme-default">
        <div class="md-tabs-container">
          <div id="tab-active" class="md-tab">
            <div class="md-card md-layout-item md-small-size-100">
              <ConfigForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :recordData="recordData" :headerColor="headerColor"></ConfigForm>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import _ from "lodash";
import Record from "@/mixins/Record";
import Page from '@/mixins/Page';

// Form validations
import { required, numeric, minLength, email } from "vuelidate/lib/validators";

export default {
  name: "hqs",
  mixins: [Record, Page],
  computed: {
    companyHqId: function () { return {"match_phrase": { "companyHqId": this.$route.params.id }}; },
    companyHqNullFilter: function() {                 
      return { filter: {esQuery: JSON.stringify(
        {"bool":{"must_not":{"exists":{"field":"companyHqId"}}}}
        )}
      }    
    },
  },
  data() {
    return {
      formConfig: {
        hasUpdatedBy: true,
        updatedByFieldName: 'hQUpdatedById',
        responseFieldName: "getHQ",
        actions: {
          save: "createHq",
          view: "getHq",
          edit: "editHq",
          new: "getHq",
          update: "updateHq",
          delete: "deleteHq"
        },
        slots: {
          basic: { label: "Basic Information", icon: "business", layout: {"x":0,"y":0,"w":12,"h":18,"i":"0"}},
        },
        listPath: "/hq",
        headerIcon: "business",
        objectName: "HQ",
        objectNamePlural: "HQs",
        editMode: false,
        pageMode: 'new',
        fields: {
          id: { label: "ID", type: "id", slot: "basic" },
          name: { label: "Name", type: "text", slot: "basic" },
          //IPCorp: { label: "IPCorp", type: "checkbox", slot: "basic" },
          active: { label: "Active", type: "switch", slot: "basic", value: true }
        },
        editTitleField: "name"
      },
      form: {
        id: "",
        name: "",
        //IPCorp: "",
        active: true
      },
      companiesList: {
        refreshData: false,
        showRelatedDialog: false,
        itemActions: [
          {
            class: "md-just-icon md-warning md-simple",
            icon: "description",
            click: "handleEdit"
          },
          {
            class: "md-just-icon md-danger md-simple",
            icon: "close",
            click: "handleDelete"
          }
        ],
        editPath: "companies",
        pageTitle: "Companies",
        pageIcon: "store",
        listQueryId: "searchCompanys",
        // updateQueryIdField: "companyHqId",
        // updateQueryId: "updateCompany",
        deleteQueryId: "deleteCompany",
        disassociateRecord: { updateQueryId: "updateCompany", updateFieldId: "companyHqId" },        
        columns: {
          name: { label: "Name", sortable: true },
          phone: { label: "Phone", sortable: true },
          phoneExt: { label: "Extension", sortable: true },
          createdAt: { label: "Created", sortable: true, dateFilter: true }
        },

        perPageOptions: [5, 10, 20, 25, 50],
        defaults: {
          sort: "createdAt",
          sortDir: "asc",
          perPage: 10
        },        
        fuseSearch: null,

        formatResponse: data => {
          let result = [];
          if (data && data.searchCompanys) {
            data.searchCompanys.items.forEach(item => {
              result.push(item);
            });
          }
          return result;
        }
      },
      relateCompaniesList: {
        hideListHeader: true,
        skipCardLayout: true,
        editPath: "companies",
        pageTitle: "Search for Company",
        pageIcon: "store",
        listQueryId: "searchCompanys",
        createMutationId: "updateCompany",
        itemActions: [
          {
            class: "md-just-icon md-simple md-warning",
            classAdded: "item.added? 'check_circle' : 'md-warning'",
            icon: "post_add",
            iconAdded: "check_circle",
            click: "handleAdd"
          }
        ],
        columns: {
          name: { label: "Name", sortable: true },
          phone: { label: "Phone", sortable: true },
          createdAt: { label: "Created", sortable: true, dateFilter: true }
        },
        perPageOptions: [5, 10, 20, 25, 50],
        defaults: {
          sort: "createdAt",
          sortDir: "asc",
          perPage: 10
        },
        fuseSearch: null,
        formatResponse: data => {
          let result = [];
          let responseKey = "searchCompanys";
          if (data && data[responseKey] !== "undefined") {
            let items = data[responseKey].items;
            items.forEach(item => {
              if (item.hq === null) {
                result.push(item);
              }
            });
          }
          return result;
        }
      },
      subscriptions: {
          'onUpdateCompany': {
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onUpdateCompany ',eventData);
              let eventRecord = eventData.value.data.onUpdateCompany;
              if (eventRecord.hq && eventRecord.hq.id === this.recordData.id) {                
                window.setTimeout(() => {
                  this.$refs.companyListRef.refresh();
                }, 300);
                /** Force a refresh on the ConfigForm component */
                this.formConfig.refreshRecordData = true;
              } else if(eventRecord.hq === null) {               
                window.setTimeout(() => {
                  this.$refs.companyListRef.refresh();
                }, 300);
              }
            },
          },

      }
    };
  },
  validations() {
    return {
      form: {
        id: {},
        name: { required, minLength: minLength(3) },
        //IPCorp: { required },
        active: {}
      }
    };
  }
};
</script>

<style lang="scss">
.md-tabs .md-tabs-navigation {
  padding-left: 15px;
  color: black;
  display: none;
  .md-tab-nav-button.md-button {
    color: black !important;

    &.active {
      color: black !important;
      border-bottom: 2px solid black;
    }
  }
}

.md-content .md-tabs-container .md-tab > .md-layout-item {
  padding-left: 0;
  padding-right: 0;
}

.md-error .md-checkbox-container {
  border-color: #f44336 !important;
}
.md-error label.md-checkbox-label {
  color: #f44336 !important;
}
</style>
